import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { UserService } from "../../services/user.service";
import { Router } from "@angular/router";
import { MdDialog } from '@angular/material';
import { DialogEditProfileComponent } from '../dialogs/dialog-edit-profile.component';

@Component({
  selector: 'app-root',
  templateUrl: '../../templates/app/app.component.html'
})
export class AppComponent implements OnInit {

  title = 'WebBest';
  isLoggedIn: boolean = false;

  @Input() user: firebase.User;

  constructor(public afAuth: AngularFireAuth,
    public userService: UserService,
    private router: Router,
    public dialog: MdDialog) {
    // location
    this.user = this.userService.getCurrentUser();
    if (this.user && this.user !== null) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

  ngOnInit() {
    this.userService.onUserChange$.subscribe( user => {
      if ( user ) {
        this.isLoggedIn = true;
         this.router.navigate(['/dashboard']);
      } else {
        this.isLoggedIn = false;
        this.router.navigate(['/']);
      }
    });
  }

  openProfileDialog() {
    this.dialog.open(DialogEditProfileComponent, {
      width: '655px'
    });
  }

  logout() {
    this.userService.logout();
  }
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/app/app.component.ts